export default "__VITE_ASSET__$TvGrWUe__"